import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_IMPORT_COST_PROVIDER_RESET = 'POST_IMPORT_COST_PROVIDER_RESET';
export const POST_IMPORT_COST_PROVIDER_LOADING = 'POST_IMPORT_COST_PROVIDER_LOADING';
export const POST_IMPORT_COST_PROVIDER_SUCCESS = 'POST_IMPORT_COST_PROVIDER_SUCCESS';
export const POST_IMPORT_COST_PROVIDER_REJECT = 'POST_IMPORT_COST_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const postImportCostProviderReset = () => ({ type: POST_IMPORT_COST_PROVIDER_RESET });
export const postImportCostProviderLoading = () => ({ type: POST_IMPORT_COST_PROVIDER_LOADING });
export const postImportCostProviderSuccess = (payload) => ({ type: POST_IMPORT_COST_PROVIDER_SUCCESS, payload });
export const postImportCostProviderReject = (payload) => ({ type: POST_IMPORT_COST_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postImportCostProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Providers/web/AddProviderCostsTemplateFile`, options);
};
